import React, { useEffect } from 'react';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../../components';
import { TextLarge, TextSmall } from '../../../../components/text';
import { ContainerButton } from '../../../../styles/global-style';
import { useForm } from 'react-hook-form';
import { FORM_REMARK } from '../form';
import { useUpdateRemark } from '../hooks/useUpdateRemark';
import { UpdateRemark } from '../../../../resources/payload';
import { Spin } from 'antd';

export const UpdateRemarkModal = ({ open, onToggle, claimData, onFetch }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({});
  const { mutate: onSubmitRemark, loading: isLoadingRemark } = useUpdateRemark({
    onSuccessCallBack: onFetch,
  });

  useEffect(() => {
    claimData?.claimId && setValue('claimId', claimData.claimId);
  }, [claimData, setValue]);

  const onSubmit = (values) => {
    const payload = UpdateRemark(values, claimData);
    onSubmitRemark(payload);
    onToggle({ defaultValue: '' });
  };

  return (
    <Spin spinning={isLoadingRemark}>
      <ModalTheme title=" " open={open} onToggle={onToggle}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <TextLarge text="หมายเหตุ" />
        </div>
        <div style={{ width: '100%', textAlign: 'left' }}>
          <TextSmall text={'ชื่อ : ' + claimData?.fullName} />
          <TextSmall text={'เลขที่เคลม : ' + claimData?.claimCode} />
        </div>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_REMARK()}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ModalTheme>
    </Spin>
  );
};
